import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局存储 dynamicTags 数据
    dynamicTags: [],
    menuIndex:'1' // 选中的菜单索引
  },
  mutations: {
    // 删除标签的 mutation
    REMOVE_TAG(state, tag) {
      const index = state.dynamicTags.indexOf(tag)
      if (index !== -1) {
        state.dynamicTags.splice(index, 1)
      }
    },
    // 添加标签的 mutation（根据需求添加）
    ADD_TAG(state, tag) {
      if (state.dynamicTags.indexOf(tag) === -1) {
        state.dynamicTags.push(tag)
      }
    },
    // 设置 menuIndex 的 mutation
    SET_MENU_INDEX(state, index) {
      state.menuIndex = index
    }
  },
  actions: {
    removeTag({ commit }, tag) {
      commit('REMOVE_TAG', tag)
    },
    addTag({ commit }, tag) {
      commit('ADD_TAG', tag)
    },
    setMenuIndex({ commit }, index) {
      commit('SET_MENU_INDEX', index)
    }
  }
})